import Presenter from 'microcosm/addons/presenter'
import Factors from '../../components/factors/aggregate'

import {
  currentAggregates,
  activeAggregate,
  highlight,
  byRegion
} from '../../queries'

class FactorsAggregatePresenter extends Presenter {
  view = Factors

  setup(repo) {
    repo.index('series', 'factors,ui.focused,ui.region', byRegion('factors'))
  }

  getModel({ location }) {
    const { query } = location

    return {
      query: query,
      region: state => state.ui.region,
      series: this.repo.memo('series', currentAggregates(query)),
      aggregate: this.repo.memo('series', highlight(query)),
      activeAggregate: this.repo.memo('series', activeAggregate(query)),
      factorCorrelations: state => state.factorCorrelations
    }
  }
}

export default FactorsAggregatePresenter



// WEBPACK FOOTER //
// ./src/presenters/factors/aggregate.js